import { HeaderBannerStream } from 'app/library/experience/models/header-banner-stream.model';
import { Posting } from 'app/library/posting/models/posting.model';
import { IExperienceCustomWidgetContentQuery } from '../interfaces/experience-custom-widget-content.interface';

// @dynamic
export class ExperienceCustomWidgetContent {
    id: string;
    name: string;
    type: string;
    maxVisibleLength: number;
    header_stream: HeaderBannerStream;
    content: { posting: Posting }[];

    constructor(query?: IExperienceCustomWidgetContentQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.type = query.type;
            this.maxVisibleLength = query.max_visible_length;
            this.content = query.content.map((experienceWidget) => ({ posting: new Posting(experienceWidget) }));
        }
    }
}
